import React, { Component } from "react";
import Content from "../components/Content";

export default class About extends Component {
  render() {
    return (
      <Content className="push-top" innerClassName="bg-white">
        <div className="row">
          <div className="col-md-6">
            <h2>
              Meet The `A` Team
              <hr/>
            </h2>
          </div>
          <div className="col-md-6">
            <p>Bacon ipsum dolor amet shank cupim meatball picanha, jerky landjaeger alcatra ham turkey
              biltong. Cupim sausage leberkas brisket capicola beef ribs pork jowl ball tip beef.</p>
          </div>
        </div>
      </Content>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/AboutUs.js